export default __webpack_public_path__ + "static/media/cpt-marvel.0b75d510.jpg";